module.exports = __webpack_public_path__ + "13_hair_gold.3d6d3adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/13_hair_gold.png
// module id = +jPI
// module chunks = 0